import { SvgIconTypeMap } from "@mui/material";
import { ContactInfoOption } from "../components/profile-page/basic-info/update-contact-info";
import { CNDateTimeFormat, IsAll } from "../utilities/general";
import moment from "moment";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { THEME_DARK_YELLOW } from "./style";

export const PAGE_SIZE = 20;

export const IsInvalid = -1;

export const DESKTOP_SIZE = 1536;

export const DEFAULT_COLOUR_INDICATOR = "#9ca3af";

export enum Language { ENGLISH = 'en-AU', ZH_CN = 'zh-CN' };

export interface VmList { totalCount: number, items: any[]; };

export interface VmListT<T> { totalCount: number, items: T[]; };

export interface VmOption { id: number, label: string | number, value?: any; short?: string };

export interface VmTabBadge { key: string | number, count: number; color?: string, description?: string, textColor?: string; };
export interface VmTab { key: string | number, label: string | number; badgeCount?: number, additionalBadges?: VmTabBadge[], color?: string, disabled?: boolean, disabledReason?: string; };

export enum ColorScheme { INITIAL, ERROR, WARNING, SUCCESS, INFO, DISABLED };

export const LATEST_AREA_VER = 2;
// ================ VM Dynamic Fields ================ 
export enum FieldType { TEXT, RICH_TEXT, NUMBER, TEXT_AREA, DATE, DATE_TIME, TIME, SELECT, CHECKBOX, RADIO, EMPTY };

export interface VmDynamicField {
  id?: number,
  fieldType: FieldType,
  name?: string,
  placeHolder?: string,
  value?: string,
  colSpan?: number,
  rows?: number,
  // selections only for select & radio buttons
  selections?: VmOption[],
  selectionsCols?: number,
  error?: boolean,
  autoWidth?: boolean,
  disabled?: boolean,
  minRows?: number,
  onlyShow?: boolean,
  startAdornment?: any,
}
// ================ End VM Dynamic Fields ================ 
// ================  VM Smart Table ================ 
export interface VmTBody {
  type: VmTBodyType,
  sortKey?: string,
  colorScheme?: ColorScheme,
  isEnable?: boolean,
  fields: string[] | VmTableButton[] | {
    compareBy: any,
    compareTo: any,
    operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",

    true: string[] | VmTableButton[] | {
      compareBy: any,
      compareTo: any,
      operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",
      true: string[],
      false: string[],
      enableIndicator: boolean,
    };
    false: string[] | VmTableButton[] | {
      compareBy: any,
      compareTo: any,
      operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",
      true: string[],
      false: string[],
      enableIndicator: boolean,
    };
  } | {
    fields: string[],
    onClick?: (req: any, event: any) => any,
    url?: string | ((req: any) => string),
  } | {
    render: (item: any, index: number) => any,
    sortBy?: (item: any) => any,
  };
};
export enum VmTBodyType {
  NO,
  TEXT,
  LONG_TEXT,
  NUMBER,
  COMPLEX,
  DESCRIPTION,
  CURRENCY,
  DATE,
  DATE_TIME,
  MONTH_YEAR,
  TIME,
  BUTTON,
  TEXT_LINK,
  TEXT_BUTTON,
  STATUS,
  CONDITION,
  URGENT,
  PRIORITY,
  IMAGES,
  CHIP_LIST,
  MULTILINE,
  CASE_DATE_TIME,
  CUSTOM
};
export interface VmTableSearch { searchFields: string[], title: string, placeHolder?: string; }
export interface VmTableButton {
  label: string,
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> | any,
  onClick: (req: any, event: any) => any,
  colorScheme?: ColorScheme,
};
// ================ End VM Smart Table ================ 

export const LangList = [Language.ENGLISH, Language.ZH_CN];

export const States = ["NSW", "ACT", "NT", "QLD", "SA", "VIC", "TAS", "WA"];

/**
 * Attachment Type
 * Use this type when uploading files
 * Therefore backend know which type of file is uploading
 */
export enum AttachmentType {
  IMAGE = 1,
  DOCUMENT = 2,
  CPD = 3,
  ASSOCIATION_MEMBERSHIP = 4,
  COMPLIANCE_DOCUMENT = 5,
  QUALIFICATION = 6,
  NEWS = 7,
  COVER_IMG = 8,
  PHOTO_ID = 9,
  PAYMENT = 10,
  CPD_INVOICE = 13,
  MF_INVOICE = 19,
  HEALTH_FUND_REPORT = 14,
  PUBLIC_DOWNLOAD = 15,
  HEALTH_FUND_IMPORT = 16,
  ALL_MEMBER_REPORT = 17,

  MEMBER_INSURANCE_DOCUMENT = 18,

  MEMBERSHIP_INVOICE = 19,
  NOTIFICATION = 20,
  INSURANCE_DOCUMENT = 21,
  INSURANCE_DOCUMENT_MEDIBANK_ZIP = 23,
  NOTIFICATION_IMAGE = 25,
  EXTERNAL_CPD_FORM = 26,
  SIGNATURE = 28,

  PUBLIC_HOMEPAGE_IMAGES = 30,
  SPEAKER_APPLICATION = 31,
}
export enum NewsCategory {
  CMASA_NEWS = 1,
  INDUSTRY_NEWS = 2,
}

export const NEWS_CATEGORY_OPTIONS = [
  { id: NewsCategory.CMASA_NEWS, label: "CMASA News" },
  { id: NewsCategory.INDUSTRY_NEWS, label: "Industry News" },
];

export enum NewsVisibilityType {
  PUBLIC_AND_MEMBER = 1,
  MEMBER_ONLY = 2,
  PUBLIC_ONLY = 3,
}

export const NEWS_VISIBILITY_OPTIONS = [
  { id: NewsVisibilityType.PUBLIC_AND_MEMBER, label: "Public & Member" },
  { id: NewsVisibilityType.MEMBER_ONLY, label: "Member Only" },
  { id: NewsVisibilityType.PUBLIC_ONLY, label: "Public Only" },
];

/**
 * Platform
 */
export enum PlatformType {
  MEMBER_WEB = 1,
  PUBLIC_WEB = 2,
  ADMIN_WEB = 3,
  MEMBER_APP = 4
}

export enum VerificationCodeType {
  EMAIL = 1,
  SMS = 2,
  APP = 3,
}


export enum CpdApprovalStatus {
  PENDING = 1,
  APPROVED = 2,
  REJECT = 3,
}

/**
 * Service Category
 */
export interface ServiceCategoryOption {
  id: number,
  serviceName: string,
  serviceDescription: string,
}

export enum MFAType { SMS = 1, EMAIL = 2, QR_CODE = 3 };
export enum MembershipLevel {
  FULL = 1,
}


export enum VerificationStatus { PENDING = 0, APPROVED = 1, REJECTED = 2, DRAFT = 3 };

export enum ContactCategory {
  SYSTEM = 1,
  SUPER_ADMIN = 2,
  ADMIN = 3,
  MEMBER = 4,
  GUEST = 5,
}

export enum CPDCategory {
  PUBLIC_CPD = 1,
  PRIVATE_CPD = 2,
  EVENT = 3,
  TRAINING_COURSE = 4,
  CPD_PACKAGE = 5,
  SUMMIT = 6,
  PAID_EVENT = 7,

  SYSTEM_IMPORTED = 999, // USED IN BACKEND ONLY
};

export interface LoginInfo {
  id: number,
  contactId: number,
  username: string,
  token: string,
  isDeleted: boolean,
  createdAt: string | null,
  createdBy: number | null,
  lastModifiedAt: string | null,
  lastModifiedBy: number | null,
  contact: AccountDetails,
}

export interface AccountDetails {
  cMemberId: number,
  id: number,
  totalCredits: number | null,
  isDeleted: boolean,
  membershipStartDate: string | null,
  membershipExpiryDate: string | null,
  cpdPackageStartDate?: string | null,
  cpdPackageExpriedDate?: string | null,
  contactCategoryId: ContactCategory,
  gender: string,
  localGender?: number,
  contactTitleId: number,

  state: string | null,

  membershipJoinDate: string | null,

  titleCategoryId: null,
  title: string | null,
  firstName: string | null,
  lastName: string | null,
  chineseLastName: string | null,
  chineseFirstName: string | null,
  dateOfBirth: string | null,
  emailAddress: string,
  phone: string,
  mobile: string | null,
  fax: string | null,
  referee: string | null,
  languagePreference: string | null,
  twofaApp: string | null,
  hasTwofaApp: boolean,
  hasTwofaSms: boolean,
  hasTwofaEmail: boolean,
  cpdLodged: string | null,
  membershipLevelId: number,
  membershipStatusId: MembershipStatus,
  username?: string;
  isClosed: boolean,

  closeMemberCpdYears?: string,

  hasReadDeclaration: boolean | null,

  isLoginAllowed: boolean,
  shouldSendNotification: boolean,

  terminateReason: string,
  terminateAt: string,

  pc: { pg: PermissionGroupCode, pl: PermissionActionCode; }[];
}

export interface TerminatedMemberConfigs {
  isLoginAllowed: boolean,
  shouldSendNotification: boolean;
}

export type SimplifiedAccountDetails = {
  isFeLoading: boolean;
  contactTitleId: number;
  gender: "Male" | "Female";
  firstName: string;
  lastName: string;
  chineseLastName: string;
  chineseFirstName: string;
  emailAddress: string;
  mobile: string;
  cMemberId: number;
  id: number;
  state: string;
  membershipStatusId: MembershipStatus;
  contactTitleName: string;
  memberServiceIds: ServiceCategory[];
};

export interface PaymentItemResponse {
  id: number,
  paidAt: string,
  isPaid: boolean,
  approvalStatusId: StatusCodes,
  approvedAt: string,
  approvedBy: number,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: number,
  isDeleted: boolean,
  orderId: number,
  paymentCategoryId: number,
  description: string,
  membershipPlanId: number,
  cpdPlanId: number,
  cpdId: number,
  membershipPlanAmount: number,
  cpdPlanAmount: number,
  cpdAmount: number,
  totalAmount: number,
  approvedByNavigation: AccountDetails,
  priceChanged?: boolean;
}

export interface PaymentOrderAttachment {
  attachmentCategoryId: number,
  createdAt?: string,
  createdBy?: number,
  extension: string,
  id: number,
  isDeleted?: boolean,
  lastModifiedAt?: string,
  lastModifiedBy?: number,
  orderId: number,
  originalName: string,
  savedName: string,
}


export interface FEPaymentOrderAttachment extends PaymentOrderAttachment {
  localPreviewLink?: string,
  localFileName?: string,
  fileName?: string,
  file?: string,
}

export interface PaymentOrderResponse {
  paymentItems: PaymentItemResponse[],
  attachments: PaymentOrderAttachment[],
  id: number,
  paidAt: string,
  isDeleted?: boolean,
  createdAt?: string,
  createdBy?: number,
  lastModifiedAt?: string,
  lastModifiedBy?: number,
  createdByNavigation?: AccountDetails,
  lastModifiedByNavigation?: AccountDetails,
  member?: AccountDetails,
  memberId: number,
  paymentMethodId: number,

  squarePaymentOrderId: string,
  squarePaymentReceiptNo: string,
  squarePaymentReceiptUrl: string,
  squarePaymentResponse: string,

  totalAmount: number,
  isPaid?: boolean,
  isCanceled?: boolean,
  priceChanged: boolean,
  paymentLogs: PaymentItemLogResponse[];
}

export enum MembershipStatus {
  FREE = 1,
  PENDING = 2,
  ACTIVATED = 3,
  REFUNDED = 4,
  DRAFT = 6,
  EXPIRED = 5,
  REJECTED = 7,
  INACTIVE = 8,
}

export enum HumanReadableMembershipStatus {
  FREE = "Free", // INCLUDES FREE AND DRAFT, REJECTED
  PENDING = "Pending", // INCLUDES PENDING
  MEMBER = "Member", // INCLUDES ACTIVATED
  INACTIVE = "Inactive", // INCLUDES INACTIVE, REFUNDED
  EXPIRED = "Expired", // INCLUDES EXPIRED
  REJECTED = "Rejected", // INCLUDES REJECTED
}

export const HumanReadableMembershipStatusMapping = {
  [HumanReadableMembershipStatus.MEMBER]: {
    text: "Active Member",
    color: "green",
    statusCodes: [MembershipStatus.ACTIVATED],
  },
  [HumanReadableMembershipStatus.PENDING]: {
    text: "Pending Member",
    color: THEME_DARK_YELLOW,
    statusCodes: [MembershipStatus.PENDING],
  },
  [HumanReadableMembershipStatus.INACTIVE]: {
    text: "Inactive Member",
    color: "gray",
    statusCodes: [MembershipStatus.INACTIVE, MembershipStatus.REFUNDED],
  },
  // [HumanReadableMembershipStatus.REJECTED]: {
  //   text: "Rejected Member",
  //   color: "red",
  //   statusCodes: [MembershipStatus.REJECTED],
  // },
  [HumanReadableMembershipStatus.FREE]: {
    text: "Free Member",
    color: "gray",
    statusCodes: [MembershipStatus.FREE, MembershipStatus.DRAFT],
  },
  [HumanReadableMembershipStatus.EXPIRED]: {
    text: "Expired Member (expired within 6 months)",
    color: "red",
    statusCodes: [MembershipStatus.EXPIRED],
  },
}

export interface LoginInfo {
  id: number,
  contactId: number,
  username: string,
  token: string,
  isDeleted: boolean,
  createdAt: string | null,
  createdBy: number | null,
  lastModifiedAt: string | null,
  lastModifiedBy: number | null,
  contact: AccountDetails,
  hasTwofaApp: boolean,
  hasTwofaEmail: boolean,
  hasTwofaSms: boolean,
  obfuscatedEmail: string,
  obfuscatedPhone: string,
}

export enum MembershipPlanOptions {
  BASIC_ONE_YEAR = 1,
  BASIC_TWO_YEAR = 2,
  BASIC_THREE_YEAR = 3,
}

export interface MembershipPlan {
  id: number,
  isDeleted: boolean,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: string,
  name: string,
  description: string,
  amount: number,
  days: number,
}

export enum ServiceCategory {
  ACU = 1,
  CHM = 2,
  REM = 3,
  MAS = 4,
  TCH = 5
}

// NEW MODALITY MUST ADD HERE
export const GetServiceCategoryName = (sc: ServiceCategory) => {
  if (sc === ServiceCategory.ACU) return "ACU";
  if (sc === ServiceCategory.CHM) return "CHM";
  if (sc === ServiceCategory.REM) return "REM";
  if (sc === ServiceCategory.MAS) return "MAS";
  if (sc === ServiceCategory.TCH) return "TCH";
  return "--";
};

export const GetServiceCategoryId = (sc: string) => {
  if (sc === "ACU") return ServiceCategory.ACU;
  if (sc === "CHM") return ServiceCategory.CHM;
  if (sc === "REM") return ServiceCategory.REM;
  if (sc === "MAS") return ServiceCategory.MAS;
  if (sc === "TCH") return ServiceCategory.TCH;
  return ServiceCategory.ACU;
};

export const MODALITY_CLINIC_MAX_LIMIT = {
  ACU: 5,
  CHM: 5,
  REM: 4,
  MAS: 4,
  TCH: 4,
}

export enum QualificationType {
  PhD = 1,
  Master = 2,
  Bachelor = 3,
  Massage = 4,
  Other = 5
}

export enum ComplianceDocumentCategory {
  WWC_WWVP_CHECK = 1,
  FIRST_AID = 2,
  PUBLIC_LIABILITY = 4,
  OTHER = 5,
  // VETASSESS = 6,
  PASSPORT = 7,
  DRIVER_LICENSE = 8,
  PHOTO_ID = 9,
}

export enum StatusCodes {
  PENDING_APPROVAL = 1,
  APPROVED = 2,
  REJECTED = 3,
  DRAFT = 4,
  PAYMENT_FAILED = 9
};


export interface ComplianceDocumentFile {
  id: number,
  name: string,
  savedName: string,
  fileName: string,
  originalName: string;
  extension: string,
  isDeleted: string,

  providerNumber?: string,

  file?: any,
  localFileName?: string,
  localPreviewLink?: string,
}

export const StatusCodeText = [
  "",
  "Pending",
  "Approved",
  "Rejected",
  "Draft",
];

export const GetStatusCodeText = (id: StatusCodes | null | undefined) => {
  if (id === StatusCodes.PAYMENT_FAILED) return "Payment Failed";
  if (!id || id < 1 || id > 4) return "--";
  return StatusCodeText[id];
};

export interface CPDContentDictionary {
  "en-AU": string,
  "zh-CN": string,
}

export interface CPDActivity {
  id: number,
  courseCode: string,
  name: string,
  title: string,
  cpdCategoryId: number,
  coverImageId?: number,
  registerDdl: string,
  organizationId?: number | null,
  presenter: string,
  hasCertificate: boolean,
  startAt: string,
  endAt: string,
  description: string,
  abstract: string,
  creditPoints: number,
  location: string,
  duration: string,
  pricing: number,
  memberPrice: number,

  galaPriceGuest: number,
  galaPriceMember: number,
  galaPrice: number,  // CALCULATED GALA PRICE

  speechApplicationRules: string,

  recordLink: string,
  zoomLink?: string,
  approvalStatusId: number,
  isPublished: boolean,
  isArchived: boolean,
  zoomNote?: string,

  cpdAttachments?: any[],
  localFileList: any[],
  note?: string,

  childrenIds: number[],
  packageIds: number[],

  summitDiscountPackageIds: number[],

  registeredCount: number,
  speakerApplicationCount: number,

  abstractDictionary?: CPDContentDictionary,
  contentDictionary?: CPDContentDictionary,
  plainContentDictionary?: CPDContentDictionary,
  titleDictionary?: CPDContentDictionary,

  // tagIds: number[],

  cpdAttachmentIds?: number[],

  fullContent?: any,

  deliveryModeId: number,
  presenterTitle: string,
}

export const STATE_OPTIONS = [
  { id: 1, value: "NSW", label: "NSW" },
  { id: 2, value: "VIC", label: "VIC" },
  { id: 3, value: "QLD", label: "QLD" },
  { id: 4, value: "SA", label: "SA" },
  { id: 5, value: "WA", label: "WA" },
  { id: 6, value: "TAS", label: "TAS" },
  { id: 7, value: "ACT", label: "ACT" },
  { id: 8, value: "NT", label: "NT" },
];


export const GENDER_OPTIONS = [
  { id: 1, value: 1, label: "Male" },
  { id: 2, value: 2, label: "Female" },
  // { id: 3, value: 3, label: "Other" },
];


export const TITLE_OPTIONS = [
  { id: 1, value: "Mr", label: "Mr" },
  { id: 2, value: "Ms", label: "Ms" },
  { id: 3, value: "Mrs", label: "Mrs" },
];

export interface BasicInfo {
  id: number,
  approvedAt: string,
  approvedBy: number,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: number,
  contactId: number,
  previousId: number,
  originalId: number,
  isDeleted: boolean,
  approvalStatusId: StatusCodes,
  homeAddress: string | null,
  homeSuburb: string | null,
  homeState: string | null,
  homePostcode: string | null,
  postalAddress: string | null,
  postalSuburb: string | null,
  postalState: string | null,
  postalPostcode: string | null,
  note?: string | null,
}


export const getContactInfoOptionText = (mode: ContactInfoOption) => {
  switch (mode) {
    case ContactInfoOption.MOBILE_NUMBER:
      return "mobile number";
    case ContactInfoOption.PHONE_NUMBER:
      return "phone number";
    case ContactInfoOption.EMAIL_ADDRESS:
      return "email address";
    default:
      return "--";
  }
};

export const MembershipBenefits = [
  { title: "Get Listed in 'Find a Doctor' Directory", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi." },
  { title: "Access to All CMASA CPD Activities", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi." },
  { title: "Invitations to CMASA Events", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi." },
  { title: "Latest Industry News & Updates", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi." },
];


export enum ChangeSectionCategory {
  BASIC_INFO = 1,
  CLINIC = 2,
  PRIVATE_BUSINESS_PRACTICE = 3,
  MEDICAL_INSURANCE = 4,
  COMPLIANCE_DOCUMENTS = 5,
  PHOTO_ID = 10,
  OTHER_ASSOCIATION_MEMBERSHIP = 6,
  QUALIFICATIONS = 7,
  DECLARATION = 8,
  MEMBERSHIP_SERVICE = 9,
  CPD_ACTIVITIES = 11,

  PAYMENT = 12,
  MEMBERSHIP_DATE = 13,
}

export const ChangeCategoryOptions = [
  { id: ChangeSectionCategory.BASIC_INFO, value: "Basic Info", label: "Basic Info" },
  { id: ChangeSectionCategory.CLINIC, value: "Clinic", label: "Clinic" },
  { id: ChangeSectionCategory.PRIVATE_BUSINESS_PRACTICE, value: "Private Business Practice", label: "Private Business Practice" },
  { id: ChangeSectionCategory.MEDICAL_INSURANCE, value: "Medical Insurance", label: "Medical Insurance" },
  { id: ChangeSectionCategory.COMPLIANCE_DOCUMENTS, value: "Compliance Documents", label: "Compliance Documents" },
  // { id: ChangeSectionCategory.PHOTO_ID, value: "Photo ID", label: "Photo ID" },
  { id: ChangeSectionCategory.OTHER_ASSOCIATION_MEMBERSHIP, value: "Other Association Membership", label: "Other Association Membership" },
  { id: ChangeSectionCategory.QUALIFICATIONS, value: "Qualifications", label: "Qualifications" },
  { id: ChangeSectionCategory.DECLARATION, value: "Declaration", label: "Declaration" },
  { id: ChangeSectionCategory.MEMBERSHIP_SERVICE, value: "Membership Service", label: "Membership Service" },
  { id: ChangeSectionCategory.CPD_ACTIVITIES, value: "CPD Activities", label: "CPD Activities" },

  { id: ChangeSectionCategory.PAYMENT, value: "Payment", label: "Payment" },
  { id: ChangeSectionCategory.MEMBERSHIP_DATE, value: "Membership Date", label: "Membership Date" },
];

export interface PhotoIdDocument {
  id: number,
  memberId: number,
  documentCategoryId: ComplianceDocumentCategory,
  memberPhotoIdAttachments: PhotoIdDocumentAttachment[],
  categoryId: number,
  startAt: string,
  expiredAt: string;
}

export interface PhotoIdDocumentAttachment extends BaseAttachment {
  id: number,
  photoId: number,
  file: string,
  localPreviewLink: string,
  localFileName: string,
}

export enum PaymentMethodCategory {
  BY_SQUARE = 1,
  BY_BANK_TRANSFER = 2,
  CREATED_BY_ADMIN = 3,
}

export enum PaymentCategory {
  MEMBERSHIP_FEE = 1,
  CPD_ADD_ON = 2,
  MEMBER_CPD_ADD_ON_PACKAGE = 3,
  CPD = 4,
}

export interface PaymentReturnObject {
  id: number,
  approvalStatusId: StatusCodes,
  approvedAt: number,
  approvedBy: number,
  cpdId: number,
  cpdPlanAmount: number,
  cpdPlanId: number,
  createdAt: string,
  createdBy: number,
  description: string,
  isDeleted: false,
  isPaid: boolean,
  lastModifiedAt: string,
  lastModifiedBy: number,
  member: AccountDetails,
  memberId: number,
  membershipPlanAmount: number,
  membershipPlanId: number,
  paidAt: string,
  paymentAttachments: paymentAttachmentReturnObject[],
  paymentCategoryId: number,
  paymentMethodId: number,
  totalAmount: number,

  approvedByNavigation: AccountDetails,
}

export interface paymentAttachmentReturnObject {
  attachmentCategoryId: number,
  createdAt: string,
  createdBy: number,
  createdByNavigation: AccountDetails,
  extension: string,
  id: number,
  isDeleted: false,
  lastModifiedAt: string,
  lastModifiedBy: number,
  lastModifiedByNavigation: AccountDetails,
  originalName: string,
  paymentId: number,
  savedName: string,
}


export interface ChangeLogReturnObject {
  approvalStatusId: StatusCodes,
  approvalStatusStr: string,
  changeFieldNameList: string[],
  approvedAt: string,
  approvedBy: number,
  approvedByNavigation: AccountDetails | null,
  changeCategoryId: number,
  createdAt: string,
  createdBy: number,
  createdByNavigation: AccountDetails | null,
  id: number,
  isDeleted: false,
  lastModifiedAt: string,
  lastModifiedBy: string,
  lastModifiedByNavigation: AccountDetails | null,
  member: AccountDetails,
  memberId: number,
  newSystemId: number,
  updatedSection: string,
  note: string,
  oriSystemId: number,
  logString?: string,
}

export enum DateRange {
  ALL_TIME = 9999,
  LAST_30_DAYS = 1,
  LAST_14_DAYS = 2,
  LAST_7_DAYS = 3,
  LAST_60_DAYS = 4,
  LAST_HALF_YEAR = 5,
  LAST_YEAR = 6,
}

export enum AmountRange {
  ALL = 9999,
  $0_50 = 1,
  $50_100 = 2,
  $100_500 = 3,
  ABOVE_500 = 4,
}

// PERMISSIONS

export enum PermissionGroupId {
  ADMINISTRATOR = 1,
  CPD_MANAGEMENT = 2,
  MEMBER_MANAGEMENT = 3,
  PAYMENT_MANAGEMENT = 4,
  EXCEL_MANAGEMENT = 5,
  NEWS_MANAGEMENT = 6,
}

export enum PermissionLevelId {
  READ_ONLY = 1,
  READ_EDIT = 2,
  READ_EDIT_CANCEL = 3,
  INACTIVE = 9999
}

export enum PermissionActionCode {
  READ = "R",
  EDIT = "E",
  CANCEL = "C"
}

export enum PermissionGroupCode {
  ADMINISTRATOR = "A",
  CPD_MANAGEMENT = "C",
  MEMBER_MANAGEMENT = "M",
  PAYMENT_MANAGEMENT = "P",
  EXCEL_MANAGEMENT = "E",
  NEWS_MANAGEMENT = "N",
}

export interface PermissionGroup {
  id: PermissionGroupId,
  permissionGroupName: string,
  permissionLevel: PermissionLevelId,
  description?: string,
  pagePaths: { path: string, label: string; }[];
  codeMapping: PermissionGroupCode,
}

export interface PermissionReqSource {
  permissionGroupId: number,
  permissionLevelId: PermissionLevelId,
}

export interface PermissionLevel {
  id: PermissionLevelId,
  label: string,
  color: string,
  bgColor: string,
}

export enum PermissionRoleCategory {
  NO_PERMISSION = 9999,
  ADMINISTRATOR = 1,
}

export const PermissionLevels: PermissionLevel[] = [
  { id: PermissionLevelId.INACTIVE, label: "No Permission", color: `text-red-400`, bgColor: `bg-red-400` },
  // { id: PermissionLevelId.READ_ONLY, label: "Read Only", color: `text-orange-400`, bgColor: `bg-orange-400` },
  // { id: PermissionLevelId.READ_EDIT, label: "Read & Edit", color: `text-sky-600`, bgColor: `bg-sky-600` },
  { id: PermissionLevelId.READ_EDIT_CANCEL, label: "Read, Edit & Cancel", color: `text-green-500`, bgColor: `bg-green-500` },
];

export const PermissionGroups: PermissionGroup[] = [
  {
    id: PermissionGroupId.ADMINISTRATOR,
    permissionGroupName: "Administrator Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to managing admin accounts, payment plan settings, etc.",
    codeMapping: PermissionGroupCode.ADMINISTRATOR,
    pagePaths: [
      // { label: "Property", path: "/property" },
      // { label: "Owner", path: "/owner" },
      // { label: "Tenant", path: "/tenant" },
      // { label: "Building Manager", path: "/building-manager" },
      // { label: "Tradesmen", path: "/contractor" },
    ]
  },
  {
    id: PermissionGroupId.CPD_MANAGEMENT,
    permissionGroupName: "CPD Management Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to managing CPD activities and approving member CPD activities.",
    codeMapping: PermissionGroupCode.CPD_MANAGEMENT,
    pagePaths: [
      { label: "CPD Activities", path: "/cpd" },
    ]
  },
  {
    id: PermissionGroupId.MEMBER_MANAGEMENT,
    permissionGroupName: "Member Management Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to member management, such as managing membership information and changes.",
    codeMapping: PermissionGroupCode.MEMBER_MANAGEMENT,
    pagePaths: [
      // { label: "Enquiry Ticket", path: "/enquiry-ticket" },
    ]
  },
  {
    id: PermissionGroupId.PAYMENT_MANAGEMENT,
    permissionGroupName: "Payment Management Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to payment management, such as approving payments.",
    codeMapping: PermissionGroupCode.PAYMENT_MANAGEMENT,
    pagePaths: [
      // { label: "Payment List", path: "/payment/list" },
      // { label: "Payment Map", path: "/payment/map" },
    ]
  },
  {
    id: PermissionGroupId.EXCEL_MANAGEMENT,
    permissionGroupName: "Report Management Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to report generation and report templates, such as generating reports for health funds.",
    codeMapping: PermissionGroupCode.EXCEL_MANAGEMENT,
    pagePaths: [
      { label: "Report", path: "/reporting" },
    ]
  },
  {
    id: PermissionGroupId.NEWS_MANAGEMENT,
    permissionGroupName: "News Management Permissions",
    permissionLevel: PermissionLevelId.INACTIVE,
    description: "Including permissions relating to news management, such as creating and editing news articles.",
    codeMapping: PermissionGroupCode.NEWS_MANAGEMENT,
    pagePaths: [
      { label: "News", path: "/news" },
    ]
  },
];

export enum EXPORTABLE_DATA_IDS {
  FIRST_NAME = 4,
  LAST_NAME = 5,
  MODALITY = 42,
  MODALITY_START_DATE = 43,
  MODALITY_END_DATE = 44,

  INSURANCE_DATE = 40,
  PROVIDER_NUMBER_MEDIBANK = 45,
  PROVIDER_NUMBER_AHM = 49,
  PROVIDER_NUMBER_ARHG = 50,
  PROVIDER_NUMBER_AU = 51,
  PROVIDER_NUMBER_BUPA = 52,
  PROVIDER_NUMBER_CBHS = 53,
  PROVIDER_NUMBER_HCF = 54,
  PROVIDER_NUMBER_NIB = 55,

  EMPTY_COLUMN = 9999,
}

// EXPORT TEMPLATE

export enum ExportReportType {
  FULL_REPORT = 1,
  CHANGE_REPORT = 2,
}

export interface ExportTemplate {
  id?: number;
  name: string;
  // description: string
  hfsId: number,
  allClinics: boolean,
  categoryId: ExportReportType,
  filedList: number[],
  columnNameList: string[],

  // NEW MODALITY MUST ADD HERE
  exportMas: boolean,
  exportTch: boolean,

  qualificationForModality: boolean;
}

export interface ExportableKey {
  id: number;
  name: string;
  sampleValue: string;
  description: string;
}

export enum ExportFileFormat {
  CSV = 1,
  EXCEL = 2,
}

export interface CreateInsuranceProviderProps {
  memberId: number,
  clinicOriId: number,
  providerCategoryId: number,
  sendToHf: boolean,
  acu: boolean,
  rem: boolean,
  chm: boolean,
  mas: boolean,
  acuNo: string,
  remNo: string,
  chmNo: string,
  masNo: string,
  acuStartAt: string,
  acuExpiredAt: string,
  remStartAt: string,
  remExpiredAt: string,
  chmStartAt: string,
  chmExpiredAt: string,
  masStartAt: string,
  masExpiredAt: string,
  note?: string,
  isClosed: boolean,
  isDeleted: boolean,
}

export interface UpdateInsuranceProviderProps extends CreateInsuranceProviderProps {
  id: number;
}

export interface ImportMemberResponse {
  success: boolean,
  errorList: ImportMemberListError[],
}

export interface ImportMemberListError {
  line: number,
  content: string[],
}

export type ImportMedibankFileResponse = {
  isSuccess: boolean,
  skipCount: number,
  totalCount: number,
  errorCount: number,
  processedCount: number,
  errorList: ImportMedibankFileError[];
};

export type ImportMedibankFileError = {
  errorMessage: string,   // "Cannot Find Member Id" || "Cannot Find Member Clinic. Member Id might be: {string.Join(",", memberIdList)}"
  errorFileName: string,
  errorFilePath: string,
};

export interface ComplianceDocumentAttachmentUpdate {
  documentId: number | undefined,
  attachmentCategoryId: number,
  originalName: string,
  id: number,
  savedName: string,
  extension: string,
  isDeleted: boolean,
  createdAt?: string,
  createdBy?: number,
  lastModifiedAt?: string,
  lastModifiedBy?: number;
}

export interface ComplianceDocumentAttachmentCreate {
  fileName: string,
  attachmentCategoryId: number,
  file: string,
  documentId: number | undefined;
}

export interface InternalNote {
  id: number,
  memberId: number,
  note: string,
  lastModifiedAt?: string,
  lastModifiedBy?: number,
  createdAt?: string,
  createdBy?: number,
  createdByNavigation?: AccountDetails,
  lastModifiedByNavigation?: AccountDetails,
}

export interface FEPaymentOrderResponse extends PaymentOrderResponse {
  memberName: string;
  cMemberId?: number;
  paymentMethod: string;
  hasAttachment: boolean;
  paymentAttachments: any[];
  approvalStatusId: StatusCodes;
  // modifiedByUserName: string;
  // approvalStatusId: StatusCodes;
}

export interface FEPaymentItemResponse extends PaymentItemResponse {
  member: AccountDetails;
  memberId: number;
  paymentAttachments: PaymentOrderAttachment[];
}

export interface RejectionReasonOption {
  id: number,
  categoryId: ChangeSectionCategory,
  subId?: number | null,
  reason: string,
  isDeleted?: boolean,
  createdBy?: number,
  createdAtFrom?: string,
  createdAtTo?: string,
  lastModifiedBy?: number,
  lastModifiedAtFrom?: string,
  lastModifiedAtTo?: string;
}

export const SYSTEM_ID = 1;

export const PaymentMethodTypes = [
  { id: PaymentMethodCategory.BY_SQUARE, value: "Square", label: "Square" },
  { id: PaymentMethodCategory.BY_BANK_TRANSFER, value: "Bank Transfer", label: "Bank Transfer" },
  { id: PaymentMethodCategory.CREATED_BY_ADMIN, value: "Created By Admin", label: "Created By Admin" },
];

export interface PaymentItemLogResponse {
  id: number,
  isDeleted: boolean,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: number,
  createdByNavigation: AccountDetails,
  lastModifiedByNavigation: AccountDetails,
  memberId: number,
  paymentOrderId: number,
  paymentItemId: number,
  key: PaymentLogChangeKey,
  description: string,
  paymentItemInfo: PaymentItemResponse;
}

export enum PaymentLogChangeKey {
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  UPDATED = "UPDATED",
  CREATED = "CREATED",
  CANCELLED = "CANCELED",
  RESTORE = "RESET",
}

export enum InsurancePdfStatus {
  UPLOADED = 1,
  RENAMING = 2,
  UPLOADING_2_DRIVE = 3,
  RENAMED = 4,
  GENERATING_DETAILS = 5,
  GENERATED = 6,
  SENDING = 7,
  FINISHED = 8
}

export enum NotificationType { EMAIL = 1, SMS = 2, APP = 3 }

export const NotificationTypeOptions = [
  { id: NotificationType.EMAIL, value: "Email", label: "Email" },
  { id: NotificationType.SMS, value: "SMS", label: "SMS" },
  { id: NotificationType.APP, value: "App", label: "App" },
];


export interface BasicNotificationGroupMap {
  id: number,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: number,
  isDeleted: boolean,
  groupId: number,
  contactId: number;
}

export interface NotificationGroupMap extends BasicNotificationGroupMap {
  contact: AccountDetails;
}

export interface NotificationGroup {
  id: number,
  name: string,
  description: string,
  isDeleted?: boolean,
  createdAt?: string,
  lastModifiedAt?: string,
  createdByNavigation?: AccountDetails,
  lastModifiedByNavigation?: AccountDetails,
  mapCount: number,
  contactIds: number[],
  maps: BasicNotificationGroupMap[],
}

// NEW MODALITY ADD HERE
export const ModalityTypeOptions = [
  { id: ServiceCategory.ACU, value: "Acupuncture", label: "Acupuncture", acronym: "ACU" },
  { id: ServiceCategory.CHM, value: "Chinese Herbal Medicine", label: "Chinese Herbal Medicine", acronym: "CHM" },
  { id: ServiceCategory.REM, value: "Remedial Massage", label: "Remedial Massage", acronym: "REM" },
  { id: ServiceCategory.MAS, value: "Massage", label: "Massage", acronym: "MAS" },
  { id: ServiceCategory.TCH, value: "Taichi", label: "Taichi", acronym: "TCH" },
];

// NEW MODALITY ADD HERE
export interface ModalityStatus {
  ACU: boolean;
  CHM: boolean;
  REM: boolean;
  MAS: boolean;
  TCH: boolean;
}

export const DefaultModalityStatus: ModalityStatus = {
  ACU: false,
  CHM: false,
  REM: false,
  MAS: false,
  TCH: false,
};

export interface CPDTagOption {
  id: number,
  cnName: string,
  enName: string,
  cnDescription: string,
  enDescription: string,
  isActive: boolean,
}

export const CPD_CATEGORY_OPTIONS = [
  { id: CPDCategory.PUBLIC_CPD, value: "Public CPD", label: "Public CPD" },
  { id: CPDCategory.PRIVATE_CPD, value: "Private CPD", label: "Private CPD" },
  { id: CPDCategory.EVENT, value: "Event", label: "Event" },
  { id: CPDCategory.TRAINING_COURSE, value: "Training Course", label: "Training Course" },
  { id: CPDCategory.CPD_PACKAGE, value: "CPD Package", label: "CPD Package" },
  { id: CPDCategory.SUMMIT, value: "Summit", label: "Summit" },
];

export const PaymentOptions = [
  { id: PaymentCategory.MEMBERSHIP_FEE, value: "Membership Recharge", label: "Membership Recharge" },
  // { id: PaymentCategory.CPD_ADD_ON, value: "CPD Add-on", label: "CPD Add-on" },
  { id: PaymentCategory.CPD, value: "Single CPD", label: "Single CPD" },
  // { id: PaymentCategory.PACKAGE, value: "CPD Package", label: "CPD Package" },
];

export enum NotificationStatus {
  DRAFT = 1,
  SCHEDULED = 2,
  READY = 3,
  SENDING = 4,
  SENT = 5,
}

export const NotificationStatusNameMap = {
  [NotificationStatus.DRAFT]: {
    text: "Draft",
    color: "gray-500",
    bgColor: "gray-100",
  },
  [NotificationStatus.SCHEDULED]: {
    text: "Scheduled",
    color: "yellow-500",
    bgColor: "yellow-100",
  },
  [NotificationStatus.READY]: {
    text: "Ready",
    color: "blue-500",
    bgColor: "blue-100",
  },
  [NotificationStatus.SENDING]: {
    text: "Sending",
    color: "orange-500",
    bgColor: "orange-100",
  },
  [NotificationStatus.SENT]: {
    text: "Sent",
    color: "green-500",
    bgColor: "green-100",
  },
};

export interface NotificationInfoBase extends NotificationGmassInfo {
  id: number,
  notificationStatusId: NotificationStatus,
  content: string,  // HTML AND SMS SHARED
  methodId: NotificationType,
  sentAt: string,
  scheduleAt: string,

  sentByFilter: string,
  newsId?: number,

  subject: string,
  senderEmail?: string,   // EMAIL "SEND FROM" ADDRESS (GMASS SENDER)
  categoryId: number,
  description: string,
  plainContent?: string;
  sentToIdsCount?: number;

  isSystem?: boolean;
  // isSuccessSent?: boolean;
  attachmentLinkList?: string[];
}

export interface GmassCampaignStatisticsModel {
  recipients?: number;
  opens?: number;
  clicks?: number;
  replies?: number;
  unsubscribes?: number;
  bounces?: number;
  blocks?: number;
}

interface NotificationGmassInfo {
  gmassCheckCounter?: number,
  gmassLastCheckAt?: string,
  gmassNextCheckAt?: string,
  gmassStatisticsObject?: GmassCampaignStatisticsModel,
  gmassStatus?: GmassStatus,
  failedEventStats?: {
    bounce?: number,
    unsubscribe?: number,
    block?: number,
    unknown?: number
  },
}

export enum GmassStatus {
  Sent = "sent",
  Scheduled = "scheduled",
  Error = "error",
  Processing = "processing",
  Unknown = "unknown",
  Cancelled = "cancelled",
  Paused = "paused",
  AbPaused = "abpaused",
}


export interface NotificationInfoResponse extends NotificationInfoBase {
  sentToIds: string,

  isDeleted?: boolean,
  createdAt?: string,
  createdBy?: number,
  lastModifiedAt?: string,
  lastModifiedBy?: number,
}

export interface NotificationInfoFE extends NotificationInfoBase {
  sentToIds: number[],
  htmlContent: string,
  smsContent: string,
}

export interface InsuranceDocumentAttachment {
  originalName: string,
  extension: string,

  file: string, // BASE64
  clinicOriIdList: number[],
  memberId: number,
  hfCategoryId?: number | null;

  localUrl?: string;
  id?: number;
}

export interface InsuranceDocumentResponse {
  id: number,
  clinicOriIds: string,
  clinicOriIdList: number[],
  savedName: string,
  extension: string,
  memberId: number,
  hfCategoryId: number,
  attachmentCategoryId: number,
  originalName: string;
  // isDeleted: boolean,
  createdAt: string,
  // createdBy: number,
  lastModifiedAt: string,
  // lastModifiedBy: number,
}


// =========== QUESTION TYPE ===========

export enum QuizOption {
  TRUE = 1,
  FALSE = 2,
}

export interface CPDQuestion {
  id: number;
  cpdId: number;
  enQuestion: string;
  cnQuestion: string;
  options: CPDQuestionOption[];
  typeId: QuestionType;
  description: string;
  answerIds: number[];
  seqId: number;

  enDescription?: string;  // QUIZ EXPLANATIONS
  cnDescription?: string;  // QUIZ EXPLANATIONS
}

export interface CPDQuestionReq extends CPDQuestion {
  newOptions: CPDQuestionOption[];
}

export interface CPDQuestionOption {
  id: number;
  enOption: string;
  cnOption: string;
  seqId: number;
  isCorrect: boolean;
  description: string;
}


export enum QuestionType {
  TRUE_FALSE = 1,
  MULTIPLE_CHOICE_SINGLE = 2,
  MULTIPLE_CHOICE_MULTI = 3,
  SHORT_ANSWER = 4,
}

export const QuestionTypeOptions = [
  { id: QuestionType.TRUE_FALSE, value: "True/False", label: "True/False" },
  { id: QuestionType.MULTIPLE_CHOICE_SINGLE, value: "Multiple Choice (Single Answer)", label: "Multiple Choice (Single Answer)" },
  { id: QuestionType.MULTIPLE_CHOICE_MULTI, value: "Multiple Choice (Multiple Answers)", label: "Multiple Choice (Multiple Answers)" },
  { id: QuestionType.SHORT_ANSWER, value: "Short Answer", label: "Short Answer" },
];


export interface MemberAnswer {
  id: number,
  answerIdList: number[],
  memberId: number,
  questionId: number,
  answer: string,
}

export interface Invoice {
  id: number,
  description: string,

  memberId?: number,
  emails?: string[],

  templateId: number,
  recipientName: string,
  recipientAddress: string,
  paidAt: string,

  isSent: boolean,

  invoiceId: string,

  invoiceItems: DefaultTemplateInvoiceItems,

  // totalAmount: number,
  // amountPaid: number,
  // balanceDue: number,

  // invoiceCategory: number,

  // memberId?: number,
  // paymentOrderId?: number,
  // isDeleted?: boolean,
  // createdAt?: string,
  // createdBy?: number,
  // lastModifiedAt?: string,
  // lastModifiedBy?: number,
}

export interface DefaultTemplateInvoiceItems {
  items: InvoiceItem[],
  totalAmount: number,
  amountPaid: number,
  balanceDue: number;
}

export enum InvoiceTemplate {
  CPD_INVOICE = 2,
  MEMBERSHIP_INVOICE = 1,
}

export const SampleInvoice: Invoice = {
  id: 0,
  templateId: InvoiceTemplate.CPD_INVOICE,
  description: "",
  paidAt: new Date().toLocaleDateString(),
  recipientName: "",
  recipientAddress: "",
  invoiceId: "",
  invoiceItems: {
    items: [],
    totalAmount: 0,
    amountPaid: 0,
    balanceDue: 0,
  },
  isSent: false
};

export const SampleInvoiceItem: InvoiceItem = {
  id: 0,
  title: "",
  qty: 1,
  unitPrice: 0,
  totalPrice: 0
};

export interface InvoiceItem {
  id: number,
  title: string,
  qty: number,
  unitPrice: number,
  totalPrice: number,
}

export enum DeliverMethod {
  ONLINE = 1,
  IN_PERSON = 2,
  HYBRID = 3,
}

export const InvoiceTemplateOptions = [
  { id: InvoiceTemplate.CPD_INVOICE, value: InvoiceTemplate.CPD_INVOICE, label: "CPD Invoice" },
  { id: InvoiceTemplate.MEMBERSHIP_INVOICE, value: InvoiceTemplate.MEMBERSHIP_INVOICE, label: "Membership Invoice" },
];

export enum STAFF_IDS {
  DR_WEI = 20049,
  TYSON = 20053,
  YUWEN = 20056,
  WILLIAM = 20054,
  SERENA = 20048,
  RUSSELL = 20296,
  STEPHEN = 21757,

  TEST_ADMIN = 10,
  CMASA_ADMIN = 20000,
}

export const GOD_MODE_USERS = [
  STAFF_IDS.DR_WEI,
  STAFF_IDS.TYSON,
  STAFF_IDS.WILLIAM,
];

// export const GOD_MODE_AND_CMASA_ADMINS = [
//   ...GOD_MODE_USERS,
//   STAFF_IDS.SERENA,
//   STAFF_IDS.RUSSELL,
//   STAFF_IDS.STEPHEN,
// ];

// CPD - EXPORT INTERNAL CPD PDF USERS 
export const CMS_ADMIN_USERS = [
  ...GOD_MODE_USERS,
  STAFF_IDS.DR_WEI,
  STAFF_IDS.SERENA,
];

export const EMPLOYEE_SIGNIN_OUT_FILTER_LIST = [
  STAFF_IDS.DR_WEI,
  // STAFF_IDS.TEST_ADMIN,
  // STAFF_IDS.CMASA_ADMIN,
  STAFF_IDS.TYSON,
  STAFF_IDS.WILLIAM,
];

export const VMOR_DEVELOPERS = [
  STAFF_IDS.TYSON,
  STAFF_IDS.WILLIAM,
];

export interface StaffLoginLog {
  id: number,
  isDeleted: boolean,
  createdAt: string,
  createdBy: number,
  // lastModifiedAt: string,
  // lastModifiedBy: null,
  memberId: number,
  description: string,
  isLogin: boolean;
}

export interface StaffLoginLogPair {
  staffId: number,
  loginTime?: string,
  logoutTime?: string,
  isRealLogoutTime?: boolean,
  workingHours?: number,
}

export interface BaseAttachment {
  id: number,
  attachmentCategoryId: AttachmentType,
  createdAt: string,
  extension: string,
  originalName: string,
  fileName?: string,
  savedName: string,
}

export interface FEOnlyAttachment {
  localPreviewLink?: string,
  localFileName: string,
  base64: string,
  originalFile?: File,
  id: number,
}

export interface FEBaseAttachment extends BaseAttachment, FEOnlyAttachment {
}

export interface NotificationAttachment extends BaseAttachment {
  notificationId: number,
}

export interface NotificationAttachmentFE extends FEBaseAttachment {
  notificationId: number,
}


export const STATIC_FILE = {
  INSURANCE_NUMBER: {
    //   "General": [
    //     // {
    //     //   filename: "CMASA HF list & News.Aug 2022.V2.pdf",
    //     //   path: "/insurance-provider/CMASA HF list & News.Aug 2022.V2.pdf"
    //     // }
    //     {
    //       filename: "CMASA HF LIST.pdf",
    //       path: "/insurance-provider/CMASA HF LIST.pdf"
    //     }
    //   ],
    //   "2": [
    //     {
    //       filename: "ARHG REQUIREMENT.pdf",
    //       path: "/insurance-provider/ARHG REQUIREMENT.pdf"
    //     }
    //   ],
    //   "4": [
    //     {
    //       filename: "Bupa - Our ancillary provider terms.pdf",
    //       path: "/insurance-provider/bupa-our-ancillary-provider-terms.pdf"
    //     }
    //   ],
    //   "6": [
    //     {
    //       filename: "HCF - terms and condition.pdf",
    //       path: "/insurance-provider/HCF terms and condition.pdf"
    //     }
    //   ],
    //   "7": [
    //     {
    //       filename: "Medibank - Recognised_Ancillary_Provider_Criteria.pdf",
    //       path: "/insurance-provider/Recognised_Ancillary_Provider_Criteria.pdf"
    //     }
    //   ]
  }
};

export const CLINIC_ADDRESS_LINE_LIMITATIONS = {
  BUPA: { addressLine1: 26, addressLine2: 30, },
  AHM: { addressLine1: 26, addressLine2: 26, }
};

export interface ResponseBase {
  id: number,
  isDeleted: boolean,
  createdAt: string,
  createdBy: number,
  lastModifiedAt: string,
  lastModifiedBy: number;
}

export type CloseMemberListItem = {
  dateFrom: string,
  dateTo: string,
  attachments: BaseAttachment[],
  closeMemberCount: number,
  closedCpdYear?: number,
  reinstateMemberCount: number,
  closeArhgMemberCount: number,
  reinstateArhgMemberCount: number,
  isClosed: boolean,
  closedAt: string | null,
} & ResponseBase;

export type CPDCreditSearchItem = {
  id: number,
  isQualified: boolean,
  // createdAt: "2025-10-23T15:03:44",
  // lastModifiedAt: "2025-10-23T15:23:52",
  member: AccountDetails,
  memberId: number,
  creditYear: number,
  totalCpdCredit: number,
  totalCmasaCredit: number,
  totalExternalCredit: number
}

export interface DownloadDocument {
  id: number,
  savedName: string,
  extension: string,
  downloadCategoryId: number,
  attachmentCategoryId: number,
  description: string,
  originalName: string,
  seqNo: number,
  isPublic: boolean,
}

export interface DownloadDocumentCategories {
  id: number,
  isDeleted: boolean,
  attachments: DownloadDocument[],
  chName: string,
  enName: string,
  description: string,
  value: number,
  label: string
}

export const GetStatusCodeColour = (status: StatusCodes | null | undefined) => {
  switch (status) {
    case StatusCodes.PENDING_APPROVAL: return "#fff3b9";
    // case StatusCodes.APPROVED: return "#FFF";
    case StatusCodes.DRAFT: return "#f3f4f6";
    case StatusCodes.REJECTED: return "#fecccc";
    default: return "#FFF";
  }
}

export const GENERAL_DOCUMENT_LOCAL_CATEGORY_ID = 999;

export type NotificationContactSearchResponse = {
  contactIds: number[],
  items: SimplifiedAccountDetails[],
  totalCount: number,
}

export enum PublicPageImageLanguageCategory {
  ENGLISH = 1,
  CHINESE = 2,
  BOTH = 3,
  ALL = 999
}

export const LANGUAGE_CATEGORY_OPTIONS = [
  { id: PublicPageImageLanguageCategory.ENGLISH, value: PublicPageImageLanguageCategory.ENGLISH, label: "English", color: "#3b82f6" },
  { id: PublicPageImageLanguageCategory.CHINESE, value: PublicPageImageLanguageCategory.CHINESE, label: "Chinese", color: "#10b981" },
  { id: PublicPageImageLanguageCategory.BOTH, value: PublicPageImageLanguageCategory.BOTH, label: "Both", color: "#f59e0b" },
];

export interface HomepageAttachment extends BaseAttachment {
  languageId: PublicPageImageLanguageCategory;
  originalName: string;
  savedName: string;
  extension: string;
  seqNo: number;
  homepageCategoryId: HomepageSectionCategory;
  description?: string;
  descriptionEn?: string;  // FE ONLY
  descriptionZh?: string;  // FE ONLY
  alignment?: { horizontal: 'left' | 'center' | 'right', vertical: 'top' | 'center' | 'bottom' }; // FE ONLY
  textColor?: string; // FE ONLY
}

export const GENERAL_CATEGORY_ID = 2;

export enum HomepageSectionCategory {
  HERO = 1,
  SUMMIT = 2,
  SUMMIT_HEADER = 3,
  JOIN_US = 4,
}

export enum NotificationFilterExpiryType {
  FA_EXPIRED = ComplianceDocumentCategory.FIRST_AID,
  PII_EXPIRED = ComplianceDocumentCategory.PUBLIC_LIABILITY,
  WWCC_EXPIRED = ComplianceDocumentCategory.WWC_WWVP_CHECK,
  MF_EXPIRED = 999
};

export interface ReportExportLog {
  id: number,
  dateFrom: string,
  dateTo: string,
  attachments: BaseAttachment[],
  closeMemberCount: number,
  reinstateMemberCount: number,
  closeArhgMemberCount: number,
  reinstateArhgMemberCount: number,
  closedCpdYear?: number,
  isClosed: boolean,
  closedAt: string | null,
  // "isDeleted": boolean,
  // "createdAt": string,
  // "createdBy": number,
  // "lastModifiedAt": string,
  // "lastModifiedBy": number
}

export const Today = moment().hour(0).minute(0).second(0);

export const TimeRangeOptions = [
  {
    name: "today",
    start: Today.clone(),
    end: Today.clone()
  },
  {
    name: "in 3 days",
    start: Today.clone(),
    end: Today.clone().add(3, 'd')
  },
  {
    name: "in 7 days",
    start: Today.clone(),
    end: Today.clone().add(7, 'd')
  },
  {
    name: "in 15 days",
    start: Today.clone(),
    end: Today.clone().add(15, 'd')
  },
  {
    name: "in 30 days",
    start: Today.clone(),
    end: Today.clone().add(30, 'd')
  },
  {
    name: "expired for 1 week",
    start: Today.clone().subtract(7, 'd'),
    end: Today.clone()
  },
]

export const EmptyLanguageSet = {
  [Language.ENGLISH]: "",
  [Language.ZH_CN]: "",
}

export type LanagugeContentSet = {
  [Language.ENGLISH]?: string,
  [Language.ZH_CN]?: string,
}

export enum SummitGalaAttendType {
  SUMMIT_ONLY = 1,
  SUMMIT_AND_GALA = 2,
  GALA_ONLY = 3,
}

export type BaseSpeakerApplication = {
  id: number
  cpdId: number,
  memberId: number,
  title: string,
  content: string,
  description?: string,
  notes: string,
  approvalStatusId: StatusCodes,
  isPublished: boolean,
  isHidden: boolean,
}

export type SpeakerApplicationResponse = {
  member: AccountDetails,
} & BaseSpeakerApplication

export type SpeakerApplicationStats = {
  totalCount: number,
  pendingCount: number,
  approvedCount: number,
  rejectedCount: number,
  publishedCount: number,
}